import { ENTITY_TYPES } from '@sales-center/common'
import { useCallback, useState } from 'react'

import { useBulkActionContext } from '../BulkActionContext'

type Props = {
  saveCallback: (date: Date | null, updateExpected) => Promise<boolean>
  entityType: ENTITY_TYPES
}

export function useActions(props: Props) {
  const { saveCallback, entityType } = props

  const {
    state: { activeBulkAction },
    dispatch,
  } = useBulkActionContext()
  const [updateExpected, setUpdateExpected] = useState<boolean>(false)
  const open = activeBulkAction === 'updateNextActionDate'

  const onOpen = useCallback(
    () =>
      dispatch({
        type: 'setActive',
        payload: 'updateNextActionDate',
      }),
    [dispatch],
  )

  const onClose = useCallback(() => dispatch({ type: 'setActive' }), [dispatch])

  const [nextActionDate, setNextActionDate] = useState<Date | null>(null)

  const onChange = useCallback(
    (selection: Date | null) => setNextActionDate(selection),
    [],
  )

  const onAccept = useCallback(
    async (date: Date | null) => {
      setNextActionDate(date)
      await saveCallback(date, updateExpected)
      if (entityType == ENTITY_TYPES.Opportunity) setUpdateExpected(false)
      onClose()
    },
    [saveCallback, entityType, updateExpected, onClose],
  )

  const onClear = useCallback(async () => {
    if (entityType == ENTITY_TYPES.Opportunity) setUpdateExpected(false)
    setNextActionDate(null)
    await saveCallback(null, false)

    onClose()
  }, [saveCallback, entityType, setUpdateExpected, onClose])

  const onCloseDialog = useCallback((_event: object, reason: string) => {
    if (reason == 'backdropClick') {
      return
    }
  }, [])

  return {
    open,
    onOpen,
    onClose,
    onChange,
    onAccept,
    nextActionDate,
    onCloseDialog,
    onClear,
    setUpdateExpected,
  }
}
